export default __webpack_public_path__ + "ec21421fae4d653c04c31348829cdba3.png";